var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPurple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4846 11.444C18.224 11.444 18.0128 11.6563 18.0128 11.9183V16.13C18.0119 16.9154 17.3789 17.5521 16.5975 17.553H3.35987C2.57848 17.5521 1.94545 16.9154 1.94453 16.13V3.76958C1.94545 2.98397 2.57848 2.34753 3.35987 2.3466H7.54874C7.80932 2.3466 8.02051 2.13426 8.02051 1.87227C8.02051 1.61028 7.80932 1.39795 7.54874 1.39795H3.35987C2.05769 1.39943 1.00245 2.46036 1.00098 3.76958V16.13C1.00245 17.4392 2.05769 18.5002 3.35987 18.5016H16.5975C17.8997 18.5002 18.9549 17.4392 18.9564 16.13V11.9185C18.9564 11.6565 18.7452 11.444 18.4846 11.444Z",
    fill: "#B63FFF",
    stroke: "#B63FFF",
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.37744 8.94688L15.266 2.021L17.4875 4.25459L10.599 11.1805L8.37744 8.94688Z",
    fill: "#B63FFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25439 12.3117L9.70948 11.628L7.93442 9.84338L7.25439 12.3117Z",
    fill: "#B63FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1024 0.84781C17.6415 0.385528 16.8953 0.385528 16.4344 0.84781L15.9341 1.35085L18.1557 3.58444L18.656 3.0814C19.116 2.61801 19.116 1.86779 18.656 1.4044L18.1024 0.84781Z",
    fill: "#B63FFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPurple);
export default __webpack_public_path__ + "static/media/edit_purple.f46b5213b9071284e8c14bdce5b76158.svg";
export { ForwardRef as ReactComponent };